import { makeStyles, SelectTabEvent, SelectTabData, Tab, TabList, tokens } from "@fluentui/react-components";
import { Switch, Route, Redirect, useRouteMatch, useHistory } from "react-router-dom";
import DevicesTab from "../modules/Devices/DevicesTab";
import CategoriesTab from "../modules/Categories/CategoriesTab";

import {
    DeviceMeetingRoomRemote20Regular,
    DeviceMeetingRoomRemote20Filled,
    AddCircle20Regular,
    AddCircle20Filled,
    ArrowImport20Regular,
    ArrowImport20Filled,
    DeviceMeetingRoom20Regular,
    DeviceMeetingRoom20Filled,
    Apps20Regular,
    Apps20Filled,
    AppsList20Regular,
    AppsList20Filled,
    AppGeneric20Regular,
    AppGeneric20Filled,
    NotepadPerson20Regular,
    NotepadPerson20Filled,
    DocumentBulletListClock20Regular,
    DocumentBulletListClock20Filled,
    bundleIcon,
    PersonDesktop20Regular,
    PersonDesktop20Filled,
} from "@fluentui/react-icons";
import UserAssignmentTab from "../modules/UserAssignments/UserAssignmentTab";
import { useCallback } from "react";

const useStyles = makeStyles({
    tab: {
        boxShadow: tokens.shadow8,
        background: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        padding: "0px 20px",
    },
    body: {
        padding: "5px 20px",
    }
});

const icons = {
    AddBundle: bundleIcon(AddCircle20Filled, AddCircle20Regular),
    ListDeviceBundle: bundleIcon(DeviceMeetingRoomRemote20Filled, DeviceMeetingRoomRemote20Regular),
    ImportBundle: bundleIcon(ArrowImport20Filled, ArrowImport20Regular),
    ListCategoryBundle: bundleIcon(AppsList20Filled, AppsList20Regular),
    GeneralStatisticBundle: bundleIcon(AppGeneric20Filled, AppGeneric20Regular),
    UserStatisticBundle: bundleIcon(NotepadPerson20Filled, NotepadPerson20Regular),
    DeviceBundle: bundleIcon(DeviceMeetingRoom20Filled, DeviceMeetingRoom20Regular),
    CategoryBundle: bundleIcon(Apps20Filled, Apps20Regular),
    UserAssignmentBundle: bundleIcon(PersonDesktop20Filled, PersonDesktop20Regular),
    StatisticBundle: bundleIcon(DocumentBulletListClock20Filled, DocumentBulletListClock20Regular),
};

const tabList = {
    devices: {
        tab: { text: "Devices", icon: <icons.DeviceBundle />, value: "devices" },
        menu: [
            { text: "List Devices", icon: <icons.ListDeviceBundle />, route: "devices" },
            { text: "Create New Device", icon: <icons.AddBundle />, route: "devices/create" },
            { text: "Import Devices", icon: <icons.ImportBundle />, route: "devices/import" },
        ]
    },
    categories: {
        tab: { text: "Categories", icon: <icons.CategoryBundle />, value: "categories" },
        menu: [
            { text: "List Categories", icon: <icons.ListCategoryBundle />, route: "categories" },
            { text: "Create New Category", icon: <icons.AddBundle />, route: "categories/create" },
        ]
    },
    userAssignments: {
        tab: { text: "Assignments", icon: <icons.UserAssignmentBundle />, value: "user-assignments" },
        menu: []
    }
};

export default function MainPage() {
    const styles = useStyles();
    const { path, url } = useRouteMatch();
    const history = useHistory();

    const onTabSelect = useCallback((_: SelectTabEvent, d: SelectTabData) => {
        history.push(`${url}/${d.value}`);
    }, [history, url]);

    return (
        <div>
            <TabList
                defaultSelectedValue={"devices"}
                appearance="subtle"
                onTabSelect={onTabSelect}
                className={styles.tab}
            >
                {Object.values(tabList).map(({ tab }) => (
                    <Tab key={tab.value} icon={tab.icon} value={tab.value}>
                        {tab.text}
                    </Tab>
                ))}
            </TabList>

            <div className={styles.body}>
                <Switch>
                    <Route path={`${path}/devices`} component={DevicesTab} />
                    <Route path={`${path}/categories`} component={CategoriesTab} />
                    <Route path={`${path}/user-assignments`} component={UserAssignmentTab} />
                    <Route path={`${path}`}>
                        <Redirect to={`${path}/devices`} />
                    </Route>
                </Switch>
            </div>
        </div>
    );
}
